/**
 * @author: Angel Labrada Massó
 * @since v0.0.1
 * @date 8/5/22
 */
import React, {memo} from 'react';
import PropTypes from 'prop-types';
import {Card, Row, Col, DatePicker} from 'antd';
import styles from './index.less';

const PreviewHourType = ({parameter}) => {

  return (
    <Card className={styles.card}>
      <Row gutter={[16,16]} className="flex items-center justify-center">
        <Col span={6}>{parameter?.parameter?.name || parameter?.parameter?.label}</Col>
        <Col span={18}><DatePicker size="large" className="w-full" /></Col>
      </Row>
    </Card>
  );
};

PreviewHourType.propTypes = {
  parameter: PropTypes.object
};

export default memo(PreviewHourType);
